"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUIFeatureAnIframeFeature = isUIFeatureAnIframeFeature;
exports.isItemBasedFeature = isItemBasedFeature;
exports.isNativeFeature = isNativeFeature;
const features_1 = require("@standardnotes/features");
function isUIFeatureAnIframeFeature(x) {
    return (0, features_1.isIframeComponentFeatureDescription)(x.featureDescription);
}
function isItemBasedFeature(x) {
    return 'uuid' in x;
}
function isNativeFeature(x) {
    return !('uuid' in x);
}
